/**
 * filterType options for AdminGetUserActivityStats and
 * ActiveUserDataForAdminDashBoardStats (ChallengeServices).
 * Keep in sync with validFilterTypes in v15/ChallengeServices/services/index.js
 */
export const ACTIVITY_STATS_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'ai', label: 'AI Workouts' },
  { value: 'non-ai', label: 'Non-AI Workouts' },
  { value: 'posture-analysis', label: 'Posture Analysis' },
  { value: 'facescan', label: 'Face Scan' },
  { value: 'skinscan', label: 'Skin Scan' },
  { value: 'goniometryscan', label: 'Goniometry Scan' },
  { value: 'bloodreport', label: 'Blood Report' },
  { value: 'hairscan', label: 'Hair Scan' },
  { value: 'ergocheck', label: 'Ergo Check' },
  { value: 'nutritionscan', label: 'Nutrition Scan' },
  { value: 'diet-completion', label: 'Diet Completion' },
  { value: 'fitness-test', label: 'Fitness Test' },
  { value: 'fitness-questions', label: 'Fitness Questions' },
  { value: 'routine-activity', label: 'Routine Activity' },
  { value: 'steps', label: 'Steps' },
  { value: 'video-session', label: 'Video Session' },
];
